import {DEFAULT_SLOT as $7230ffa83bc0c2cf$export$c62b8e45d58ddad9, dom as $7230ffa83bc0c2cf$export$df3a06d6289f983e, Provider as $7230ffa83bc0c2cf$export$2881499e37b75b9a, useContextProps as $7230ffa83bc0c2cf$export$29f1550f4b0d4415, useRenderProps as $7230ffa83bc0c2cf$export$4d86445c2cf5e3, useSlot as $7230ffa83bc0c2cf$export$9d4c57ee4c6ffdd8} from "./utils.mjs";
import {CollectionRendererContext as $263ab7fc0f95ccdb$export$4feb769f8ddf26c5, SectionContext as $263ab7fc0f95ccdb$export$d40e14dec8b060a8} from "./Collection.mjs";
import {DragAndDropContext as $f9554a667e4f0374$export$d188a835a7bc5783, DropIndicatorContext as $f9554a667e4f0374$export$f55761759794cf55, useDndPersistedKeys as $f9554a667e4f0374$export$d1e8e3fbb7461f6, useRenderDropIndicator as $f9554a667e4f0374$export$971707d8a129a1f7} from "./DragAndDrop.mjs";
import {HeaderContext as $53e61d82d8b8611d$export$e0e4026c12a8bdbb} from "./Header.mjs";
import {SelectableCollectionContext as $4b38b5b75ecc6208$export$b0d3ecf7112093a7} from "./Autocomplete.mjs";
import {SelectionIndicatorContext as $91fe5e721c7f36c1$export$c9549807523555e0} from "./SelectionIndicator.mjs";
import {SeparatorContext as $e28ab3efe3e87743$export$6615d83f6de245ce} from "./Separator.mjs";
import {SharedElementTransition as $792f28e438b9ad5f$export$758399f318e6385a} from "./SharedElementTransition.mjs";
import {TextContext as $efe09c6d1c304b50$export$9afb8bc826b033ea} from "./Text.mjs";
import {useListBox as $c4d6w$useListBox, useListBoxSection as $c4d6w$useListBoxSection, useOption as $c4d6w$useOption} from "react-aria/useListBox";
import {Collection as $c4d6w$Collection} from "react-aria/Collection";
import {CollectionBuilder as $c4d6w$CollectionBuilder, createBranchComponent as $c4d6w$createBranchComponent, createLeafComponent as $c4d6w$createLeafComponent} from "react-aria/CollectionBuilder";
import {filterDOMProps as $c4d6w$filterDOMProps} from "react-aria/filterDOMProps";
import {FocusScope as $c4d6w$FocusScope} from "react-aria/FocusScope";
import {inertValue as $c4d6w$inertValue} from "react-aria/private/utils/inertValue";
import {SectionNode as $c4d6w$SectionNode, ItemNode as $c4d6w$ItemNode, LoaderNode as $c4d6w$LoaderNode} from "react-aria/private/collections/BaseCollection";
import {ListKeyboardDelegate as $c4d6w$ListKeyboardDelegate} from "react-aria/ListKeyboardDelegate";
import {useListState as $c4d6w$useListState, UNSTABLE_useFilteredListState as $c4d6w$UNSTABLE_useFilteredListState} from "react-stately/useListState";
import {useLoadMoreSentinel as $c4d6w$useLoadMoreSentinel} from "react-aria/private/utils/useLoadMoreSentinel";
import {mergeProps as $c4d6w$mergeProps} from "react-aria/mergeProps";
import $c4d6w$react, {createContext as $c4d6w$createContext, forwardRef as $c4d6w$forwardRef, useContext as $c4d6w$useContext, useMemo as $c4d6w$useMemo, useRef as $c4d6w$useRef, useEffect as $c4d6w$useEffect} from "react";
import {useCollator as $c4d6w$useCollator} from "react-aria/useCollator";
import {useFocus as $c4d6w$useFocus} from "react-aria/useFocus";
import {useFocusRing as $c4d6w$useFocusRing} from "react-aria/useFocusRing";
import {useHover as $c4d6w$useHover} from "react-aria/useHover";
import {useKeyboard as $c4d6w$useKeyboard} from "react-aria/useKeyboard";
import {useLocale as $c4d6w$useLocale} from "react-aria/I18nProvider";
import {useObjectRef as $c4d6w$useObjectRef} from "react-aria/useObjectRef";

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 



























const $928221da08ecbc62$export$7ff8f37d2d81a48d = /*#__PURE__*/ (0, $c4d6w$createContext)(null);
const $928221da08ecbc62$export$7c5906fe4f1f2af2 = /*#__PURE__*/ (0, $c4d6w$createContext)(null);
const $928221da08ecbc62$export$41f133550aa26f48 = /*#__PURE__*/ (0, $c4d6w$forwardRef)(function ListBox(props, ref) {
    [props, ref] = (0, $7230ffa83bc0c2cf$export$29f1550f4b0d4415)(props, ref, $928221da08ecbc62$export$7ff8f37d2d81a48d);
    let state = (0, $c4d6w$useContext)($928221da08ecbc62$export$7c5906fe4f1f2af2);
    // The structure of ListBox is a bit strange because it needs to work inside other components like ComboBox and Select.
    // Those components render two copies of their children so that the collection can be built even when the popover is closed.
    // The first copy sends a collection document via context which we render the collection portal into.
    // The second copy sends a ListState object via context which we use to render the ListBox without rebuilding the state.
    // Otherwise, we have a standalone ListBox, so we need to create a collection and state ourselves.
    if (state) return /*#__PURE__*/ (0, $c4d6w$react).createElement($928221da08ecbc62$var$ListBoxInner, {
        state: state,
        props: props,
        listBoxRef: ref
    });
    return /*#__PURE__*/ (0, $c4d6w$react).createElement((0, $c4d6w$CollectionBuilder), {
        content: /*#__PURE__*/ (0, $c4d6w$react).createElement((0, $c4d6w$Collection), props)
    }, (collection)=>/*#__PURE__*/ (0, $c4d6w$react).createElement($928221da08ecbc62$var$StandaloneListBox, {
            props: props,
            listBoxRef: ref,
            collection: collection
        }));
});
function $928221da08ecbc62$var$StandaloneListBox({ props: props, listBoxRef: listBoxRef, collection: collection }) {
    props = {
        ...props,
        collection: collection,
        children: null,
        items: null
    };
    let { layoutDelegate: layoutDelegate } = (0, $c4d6w$useContext)((0, $263ab7fc0f95ccdb$export$4feb769f8ddf26c5));
    let state = (0, $c4d6w$useListState)({
        ...props,
        layoutDelegate: layoutDelegate
    });
    return /*#__PURE__*/ (0, $c4d6w$react).createElement($928221da08ecbc62$var$ListBoxInner, {
        state: state,
        props: props,
        listBoxRef: listBoxRef
    });
}
function $928221da08ecbc62$var$ListBoxInner({ state: inputState, props: props, listBoxRef: listBoxRef }) {
    [props, listBoxRef] = (0, $7230ffa83bc0c2cf$export$29f1550f4b0d4415)(props, listBoxRef, (0, $4b38b5b75ecc6208$export$b0d3ecf7112093a7));
    let { dragAndDropHooks: dragAndDropHooks, layout: layout = 'stack', orientation: orientation = 'vertical', filter: filter } = props;
    let state = (0, $c4d6w$UNSTABLE_useFilteredListState)(inputState, filter);
    let { collection: collection, selectionManager: selectionManager } = state;
    let isListDraggable = !!dragAndDropHooks?.useDraggableCollectionState;
    let isListDroppable = !!dragAndDropHooks?.useDroppableCollectionState;
    let { direction: direction } = (0, $c4d6w$useLocale)();
    let { disabledBehavior: disabledBehavior, disabledKeys: disabledKeys } = selectionManager;
    let collator = (0, $c4d6w$useCollator)({
        usage: 'search',
        sensitivity: 'base'
    });
    let { isVirtualized: isVirtualized, layoutDelegate: layoutDelegate, dropTargetDelegate: ctxDropTargetDelegate, CollectionRoot: CollectionRoot } = (0, $c4d6w$useContext)((0, $263ab7fc0f95ccdb$export$4feb769f8ddf26c5));
    let keyboardDelegate = (0, $c4d6w$useMemo)(()=>props.keyboardDelegate || new (0, $c4d6w$ListKeyboardDelegate)({
            collection: collection,
            collator: collator,
            ref: listBoxRef,
            disabledKeys: disabledKeys,
            disabledBehavior: disabledBehavior,
            layout: layout,
            orientation: orientation,
            direction: direction,
            layoutDelegate: layoutDelegate
        }), [
        collection,
        collator,
        listBoxRef,
        disabledBehavior,
        disabledKeys,
        orientation,
        direction,
        props.keyboardDelegate,
        layout,
        layoutDelegate
    ]);
    let { listBoxProps: listBoxProps } = (0, $c4d6w$useListBox)({
        ...props,
        shouldSelectOnPressUp: isListDraggable || props.shouldSelectOnPressUp,
        keyboardDelegate: keyboardDelegate,
        isVirtualized: isVirtualized
    }, state, listBoxRef);
    let dragHooksProvided = (0, $c4d6w$useRef)(isListDraggable);
    let dropHooksProvided = (0, $c4d6w$useRef)(isListDroppable);
    (0, $c4d6w$useEffect)(()=>{
        if (process.env.NODE_ENV === 'production') return;
        if (dragHooksProvided.current !== isListDraggable) console.warn('Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.');
        if (dropHooksProvided.current !== isListDroppable) console.warn('Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.');
    }, [
        isListDraggable,
        isListDroppable
    ]);
    let dragState = undefined;
    let dropState = undefined;
    let droppableCollection = undefined;
    let isRootDropTarget = false;
    let dragPreview = null;
    let preview = (0, $c4d6w$useRef)(null);
    if (isListDraggable && dragAndDropHooks) {
        dragState = dragAndDropHooks.useDraggableCollectionState({
            collection: collection,
            selectionManager: selectionManager,
            preview: dragAndDropHooks.renderDragPreview ? preview : undefined
        });
        dragAndDropHooks.useDraggableCollection({}, dragState, listBoxRef);
        let DragPreview = dragAndDropHooks.DragPreview;
        dragPreview = dragAndDropHooks.renderDragPreview ? /*#__PURE__*/ (0, $c4d6w$react).createElement(DragPreview, {
            ref: preview
        }, dragAndDropHooks.renderDragPreview) : null;
    }
    if (isListDroppable && dragAndDropHooks) {
        dropState = dragAndDropHooks.useDroppableCollectionState({
            collection: collection,
            selectionManager: selectionManager
        });
        let dropTargetDelegate = dragAndDropHooks.dropTargetDelegate || ctxDropTargetDelegate || new dragAndDropHooks.ListDropTargetDelegate(collection, listBoxRef, {
            orientation: orientation,
            layout: layout,
            direction: direction
        });
        droppableCollection = dragAndDropHooks.useDroppableCollection({
            keyboardDelegate: keyboardDelegate,
            dropTargetDelegate: dropTargetDelegate
        }, dropState, listBoxRef);
        isRootDropTarget = dropState.isDropTarget({
            type: 'root'
        });
    }
    let { focusProps: focusProps, isFocused: isFocused, isFocusVisible: isFocusVisible } = (0, $c4d6w$useFocusRing)();
    let isEmpty = state.collection.size === 0;
    let renderValues = {
        isDropTarget: isRootDropTarget,
        isEmpty: isEmpty,
        isFocused: isFocused,
        isFocusVisible: isFocusVisible,
        layout: props.layout || 'stack',
        orientation: orientation,
        state: state
    };
    let renderProps = (0, $7230ffa83bc0c2cf$export$4d86445c2cf5e3)({
        ...props,
        children: undefined,
        defaultClassName: 'react-aria-ListBox',
        values: renderValues
    });
    let emptyState = null;
    if (isEmpty && props.renderEmptyState) emptyState = /*#__PURE__*/ (0, $c4d6w$react).createElement("div", {
        // eslint-disable-next-line
        role: "option",
        style: {
            display: 'contents'
        }
    }, props.renderEmptyState(renderValues));
    let DOMProps = (0, $c4d6w$filterDOMProps)(props, {
        global: true
    });
    return /*#__PURE__*/ (0, $c4d6w$react).createElement((0, $c4d6w$FocusScope), null, /*#__PURE__*/ (0, $c4d6w$react).createElement((0, $7230ffa83bc0c2cf$export$df3a06d6289f983e).div, {
        ...(0, $c4d6w$mergeProps)(DOMProps, renderProps, listBoxProps, focusProps, droppableCollection?.collectionProps),
        ref: listBoxRef,
        slot: props.slot || undefined,
        onScroll: props.onScroll,
        "data-drop-target": isRootDropTarget || undefined,
        "data-empty": isEmpty || undefined,
        "data-focused": isFocused || undefined,
        "data-focus-visible": isFocusVisible || undefined,
        "data-layout": props.layout || 'stack',
        "data-orientation": orientation
    }, /*#__PURE__*/ (0, $c4d6w$react).createElement((0, $7230ffa83bc0c2cf$export$2881499e37b75b9a), {
        values: [
            [
                $928221da08ecbc62$export$7ff8f37d2d81a48d,
                props
            ],
            [
                $928221da08ecbc62$export$7c5906fe4f1f2af2,
                state
            ],
            [
                (0, $f9554a667e4f0374$export$d188a835a7bc5783),
                {
                    dragAndDropHooks: dragAndDropHooks,
                    dragState: dragState,
                    dropState: dropState
                }
            ],
            [
                (0, $e28ab3efe3e87743$export$6615d83f6de245ce),
                {
                    elementType: 'div'
                }
            ],
            [
                (0, $f9554a667e4f0374$export$f55761759794cf55),
                {
                    render: $928221da08ecbc62$var$ListBoxDropIndicatorWrapper
                }
            ],
            [
                (0, $263ab7fc0f95ccdb$export$d40e14dec8b060a8),
                {
                    name: 'ListBoxSection',
                    render: $928221da08ecbc62$var$ListBoxSectionInner
                }
            ]
        ]
    }, /*#__PURE__*/ (0, $c4d6w$react).createElement((0, $792f28e438b9ad5f$export$758399f318e6385a), null, /*#__PURE__*/ (0, $c4d6w$react).createElement(CollectionRoot, {
        collection: collection,
        scrollRef: listBoxRef,
        persistedKeys: (0, $f9554a667e4f0374$export$d1e8e3fbb7461f6)(selectionManager, dragAndDropHooks, dropState),
        renderDropIndicator: (0, $f9554a667e4f0374$export$971707d8a129a1f7)(dragAndDropHooks, dropState)
    }))), emptyState, dragPreview));
}
function $928221da08ecbc62$var$ListBoxSectionInner(props, ref, section, className = 'react-aria-ListBoxSection') {
    let state = (0, $c4d6w$useContext)($928221da08ecbc62$export$7c5906fe4f1f2af2);
    let { dragAndDropHooks: dragAndDropHooks, dropState: dropState } = (0, $c4d6w$useContext)((0, $f9554a667e4f0374$export$d188a835a7bc5783));
    let { CollectionBranch: CollectionBranch } = (0, $c4d6w$useContext)((0, $263ab7fc0f95ccdb$export$4feb769f8ddf26c5));
    let [headingRef, heading] = (0, $7230ffa83bc0c2cf$export$9d4c57ee4c6ffdd8)();
    let { headingProps: headingProps, groupProps: groupProps } = (0, $c4d6w$useListBoxSection)({
        heading: heading,
        'aria-label': props['aria-label'] ?? undefined
    });
    let renderProps = (0, $7230ffa83bc0c2cf$export$4d86445c2cf5e3)({
        ...props,
        id: undefined,
        children: undefined,
        defaultClassName: className,
        values: undefined
    });
    let DOMProps = (0, $c4d6w$filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    return /*#__PURE__*/ (0, $c4d6w$react).createElement((0, $7230ffa83bc0c2cf$export$df3a06d6289f983e).section, {
        ...(0, $c4d6w$mergeProps)(DOMProps, renderProps, groupProps),
        ref: ref
    }, /*#__PURE__*/ (0, $c4d6w$react).createElement((0, $53e61d82d8b8611d$export$e0e4026c12a8bdbb).Provider, {
        value: {
            ...headingProps,
            ref: headingRef
        }
    }, /*#__PURE__*/ (0, $c4d6w$react).createElement(CollectionBranch, {
        collection: state.collection,
        parent: section,
        renderDropIndicator: (0, $f9554a667e4f0374$export$971707d8a129a1f7)(dragAndDropHooks, dropState)
    })));
}
const $928221da08ecbc62$export$dca12b0bb56e4fc = /*#__PURE__*/ (0, $c4d6w$createBranchComponent)((0, $c4d6w$SectionNode), $928221da08ecbc62$var$ListBoxSectionInner);
const $928221da08ecbc62$export$a11e76429ed99b4 = /*#__PURE__*/ (0, $c4d6w$createLeafComponent)((0, $c4d6w$ItemNode), function ListBoxItem(props, forwardedRef, item) {
    let ref = (0, $c4d6w$useObjectRef)(forwardedRef);
    let state = (0, $c4d6w$useContext)($928221da08ecbc62$export$7c5906fe4f1f2af2);
    let { dragAndDropHooks: dragAndDropHooks, dragState: dragState, dropState: dropState } = (0, $c4d6w$useContext)((0, $f9554a667e4f0374$export$d188a835a7bc5783));
    let { optionProps: optionProps, labelProps: labelProps, descriptionProps: descriptionProps, ...states } = (0, $c4d6w$useOption)({
        key: item.key,
        'aria-label': props?.['aria-label']
    }, state, ref);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $c4d6w$useHover)({
        isDisabled: !states.allowsSelection && !states.hasAction,
        onHoverStart: item.props.onHoverStart,
        onHoverChange: item.props.onHoverChange,
        onHoverEnd: item.props.onHoverEnd
    });
    let { keyboardProps: keyboardProps } = (0, $c4d6w$useKeyboard)(props);
    let { focusProps: focusProps } = (0, $c4d6w$useFocus)(props);
    let draggableItem = null;
    if (dragState && dragAndDropHooks) draggableItem = dragAndDropHooks.useDraggableItem({
        key: item.key,
        hasAction: states.hasAction
    }, dragState);
    let droppableItem = null;
    if (dropState && dragAndDropHooks) droppableItem = dragAndDropHooks.useDroppableItem({
        target: {
            type: 'item',
            key: item.key,
            dropPosition: 'on'
        }
    }, dropState, ref);
    let isDragging = dragState && dragState.isDragging(item.key);
    let renderProps = (0, $7230ffa83bc0c2cf$export$4d86445c2cf5e3)({
        ...props,
        id: undefined,
        children: props.children,
        defaultClassName: 'react-aria-ListBoxItem',
        values: {
            ...states,
            isHovered: isHovered,
            selectionMode: state.selectionManager.selectionMode,
            selectionBehavior: state.selectionManager.selectionBehavior,
            allowsDragging: !!dragState,
            isDragging: isDragging,
            isDropTarget: droppableItem?.isDropTarget
        }
    });
    (0, $c4d6w$useEffect)(()=>{
        if (!item.textValue && process.env.NODE_ENV !== 'production') console.warn('A `textValue` prop is required for <ListBoxItem> elements with non-plain text children in order to support accessibility features such as type to select.');
    }, [
        item.textValue
    ]);
    let ElementType = props.href ? (0, $7230ffa83bc0c2cf$export$df3a06d6289f983e).a : (0, $7230ffa83bc0c2cf$export$df3a06d6289f983e).div;
    let DOMProps = (0, $c4d6w$filterDOMProps)(props, {
        global: true
    });
    delete DOMProps.id;
    delete DOMProps.onClick;
    if (props.href && optionProps.tabIndex == null) optionProps.tabIndex = -1;
    return /*#__PURE__*/ (0, $c4d6w$react).createElement(ElementType, {
        ...(0, $c4d6w$mergeProps)(DOMProps, renderProps, optionProps, hoverProps, keyboardProps, focusProps, draggableItem?.dragProps, droppableItem?.dropProps),
        ref: ref,
        "data-allows-dragging": !!dragState || undefined,
        "data-selected": states.isSelected || undefined,
        "data-disabled": states.isDisabled || undefined,
        "data-hovered": isHovered || undefined,
        "data-focused": states.isFocused || undefined,
        "data-focus-visible": states.isFocusVisible || undefined,
        "data-pressed": states.isPressed || undefined,
        "data-dragging": isDragging || undefined,
        "data-drop-target": droppableItem?.isDropTarget || undefined,
        "data-selection-mode": state.selectionManager.selectionMode === 'none' ? undefined : state.selectionManager.selectionMode
    }, /*#__PURE__*/ (0, $c4d6w$react).createElement((0, $7230ffa83bc0c2cf$export$2881499e37b75b9a), {
        values: [
            [
                (0, $efe09c6d1c304b50$export$9afb8bc826b033ea),
                {
                    slots: {
                        [(0, $7230ffa83bc0c2cf$export$c62b8e45d58ddad9)]: labelProps,
                        label: labelProps,
                        description: descriptionProps
                    }
                }
            ],
            [
                (0, $91fe5e721c7f36c1$export$c9549807523555e0),
                {
                    isSelected: states.isSelected
                }
            ]
        ]
    }, renderProps.children));
});
function $928221da08ecbc62$var$ListBoxDropIndicatorWrapper(props, ref) {
    ref = (0, $c4d6w$useObjectRef)(ref);
    let { dragAndDropHooks: dragAndDropHooks, dropState: dropState } = (0, $c4d6w$useContext)((0, $f9554a667e4f0374$export$d188a835a7bc5783));
    let { dropIndicatorProps: dropIndicatorProps, isHidden: isHidden, isDropTarget: isDropTarget } = dragAndDropHooks.useDropIndicator(props, dropState, ref);
    if (isHidden) return null;
    return /*#__PURE__*/ (0, $c4d6w$react).createElement($928221da08ecbc62$var$ListBoxDropIndicatorForwardRef, {
        ...props,
        dropIndicatorProps: dropIndicatorProps,
        isDropTarget: isDropTarget,
        ref: ref
    });
}
function $928221da08ecbc62$var$ListBoxDropIndicator(props, ref) {
    let { dropIndicatorProps: dropIndicatorProps, isDropTarget: isDropTarget, ...otherProps } = props;
    let renderProps = (0, $7230ffa83bc0c2cf$export$4d86445c2cf5e3)({
        ...otherProps,
        defaultClassName: 'react-aria-DropIndicator',
        values: {
            isDropTarget: isDropTarget
        }
    });
    return /*#__PURE__*/ (0, $c4d6w$react).createElement((0, $7230ffa83bc0c2cf$export$df3a06d6289f983e).div, {
        ...dropIndicatorProps,
        ...renderProps,
        role: "option",
        ref: ref,
        "data-drop-target": isDropTarget || undefined
    });
}
const $928221da08ecbc62$var$ListBoxDropIndicatorForwardRef = /*#__PURE__*/ (0, $c4d6w$forwardRef)($928221da08ecbc62$var$ListBoxDropIndicator);
const $928221da08ecbc62$export$8e6d031a08cf56a1 = (0, $c4d6w$createLeafComponent)((0, $c4d6w$LoaderNode), function ListBoxLoadingIndicator(props, ref, item) {
    let state = (0, $c4d6w$useContext)($928221da08ecbc62$export$7c5906fe4f1f2af2);
    let { isLoading: isLoading, onLoadMore: onLoadMore, scrollOffset: scrollOffset, ...otherProps } = props;
    let sentinelRef = (0, $c4d6w$useRef)(null);
    let memoedLoadMoreProps = (0, $c4d6w$useMemo)(()=>({
            onLoadMore: onLoadMore,
            collection: state?.collection,
            sentinelRef: sentinelRef,
            scrollOffset: scrollOffset
        }), [
        onLoadMore,
        scrollOffset,
        state?.collection
    ]);
    (0, $c4d6w$useLoadMoreSentinel)(memoedLoadMoreProps, sentinelRef);
    let renderProps = (0, $7230ffa83bc0c2cf$export$4d86445c2cf5e3)({
        ...otherProps,
        id: undefined,
        children: item.rendered,
        defaultClassName: 'react-aria-ListBoxLoadingIndicator',
        values: undefined
    });
    let optionProps = {
        // For Android talkback
        tabIndex: -1
    };
    return /*#__PURE__*/ (0, $c4d6w$react).createElement((0, $c4d6w$react).Fragment, null, /*#__PURE__*/ (0, $c4d6w$react).createElement("div", {
        style: {
            position: 'relative',
            width: 0,
            height: 0
        },
        inert: (0, $c4d6w$inertValue)(true)
    }, /*#__PURE__*/ (0, $c4d6w$react).createElement("div", {
        "data-testid": "loadMoreSentinel",
        ref: sentinelRef,
        style: {
            position: 'absolute',
            height: 1,
            width: 1
        }
    })), isLoading && renderProps.children && /*#__PURE__*/ (0, $c4d6w$react).createElement((0, $7230ffa83bc0c2cf$export$df3a06d6289f983e).div, {
        ...(0, $c4d6w$mergeProps)((0, $c4d6w$filterDOMProps)(props, {
            global: true
        }), optionProps),
        ...renderProps,
        // aria-selected isn't needed here since this option is not selectable.
        role: "option",
        ref: ref
    }, renderProps.children));
});


export {$928221da08ecbc62$export$7ff8f37d2d81a48d as ListBoxContext, $928221da08ecbc62$export$7c5906fe4f1f2af2 as ListStateContext, $928221da08ecbc62$export$41f133550aa26f48 as ListBox, $928221da08ecbc62$export$dca12b0bb56e4fc as ListBoxSection, $928221da08ecbc62$export$a11e76429ed99b4 as ListBoxItem, $928221da08ecbc62$export$8e6d031a08cf56a1 as ListBoxLoadMoreItem};
//# sourceMappingURL=ListBox.mjs.map
